import React, { useEffect, useMemo, useState } from "react";
import { AiOutlineFullscreenExit } from "react-icons/ai";
import Participant from "./Participant";
import { User } from "models/User";
import { useSelector } from "react-redux";
import { RootState } from "store";
import ParticipantExpanded from "./ParticipantExpanded";
import useMediaQuery from "hooks/useMediaQuery";

interface Props {
  data: any;
}

const getAspectRatio = (count: number): string => {
  if (count === 1) return "16 / 9";  // widescreen
  if (count === 2) return "4 / 3";
  if (count === 3) return "4 / 3";   // classic
  return "3 / 2";                    // fallback (≈1.5)
};


const ParticipantExpandedTable = ({ data }: Props) => {
  const consumers: any = useSelector(
    (state: RootState) => state.live.settings.consumers
  );
  const [sidebar, setSidebar] = useState({ SessionSidebarWidth: 0, ParticipantSidebarWidth: 0, sidebarOpen: false });
  const profileData = useSelector((state: any) => state?.auth?.user as User);
  const producers = useSelector(
    (state: RootState) => state.live.settings.producers
  );
  const isMobileOrTablet = useMediaQuery("(max-width: 1024px)");
  const { participantPanelWidth, sessionPanelWidth, participantPanelOpen, sessionPlanPanelOpen } = useSelector((state: RootState) => state.countReducer);
  const getTrack = (email: string) => {
    if (!consumers || !producers || !profileData) {
      console.warn("No consumers, producers, or profileData available");
      return { audio: null, video: null };
    }

    if (email === profileData.email) {
      const validProducers = Object.values(producers).filter(
        (producer: any) => producer !== undefined
      );

      const videoProducer: any = validProducers.find(
        (producer: any) => producer?.kind === "video"
      );
      const audioProducer: any = validProducers.find(
        (producer: any) => producer?.kind === "audio"
      );

      return {
        audio: audioProducer
          ? { track: audioProducer.track, locallyPaused: audioProducer.paused }
          : null,
        video: videoProducer
          ? { track: videoProducer.track, locallyPaused: videoProducer.paused }
          : null,
      };
    }

    let audioConsumer = null;
    let videoConsumer = null;

    for (const id in consumers) {
      if (consumers[id].peerId === email && consumers[id].track) {
        if (consumers[id].kind === "audio") {
          audioConsumer = consumers[id];
        } else if (
          consumers[id].kind === "video" &&
          !consumers[id].appData?.share
        ) {
          videoConsumer = consumers[id];
        }
      }
    }

    return { audio: audioConsumer, video: videoConsumer };
  };
  useEffect(() => {
    setSidebar({
      ParticipantSidebarWidth: participantPanelWidth,
      SessionSidebarWidth: sessionPanelWidth,
      sidebarOpen: true,
    });
  }, [participantPanelWidth, sessionPanelWidth,]);

  const totalParticipants = data.length;

  const aspectRatio = getAspectRatio(totalParticipants);
  const columns = isMobileOrTablet ? Math.min(totalParticipants, 2) : Math.min(totalParticipants, 3);
  const rows = Math.ceil(totalParticipants / columns);

  const gridStyle = {
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
  };

  return (
    <div className="mobile:mx-0 w-full h-full">
      {/* <div className="text-2xl text-white mobile:justify-center flex justify-start m-2 ">
        <div className="bg-gray-600 p-2 rounded-lg opacity-50">
          <AiOutlineFullscreenExit onClick={view} />
        </div>
      </div> */}
      <div className="grid text-white mobile:gap-2  m-2 gap-2" style={gridStyle}>
        {data.map((seat: any, index: any) => (
          <div className="w-full mobile:w-full h-full mobile:flex mobile:justify-center" key={index}>
            <ParticipantExpanded
              key={seat.id || seat.participant_id}
              name={seat.participant_name || seat.name}
              id={seat.participant_id || seat.id}
              profilePhoto={seat.profilePhoto}
              size="9"
              radius="small"
              streamArray={getTrack(seat.participant_email || seat.email)}
              aspectRatio={aspectRatio}
              video="yes"
              audio="yes"
              style={aspectRatio === "16 / 9" ? isMobileOrTablet ? {} : { maxHeight: "70%" } : {}}
            />
          </div>
        ))}
      </div>
      {/* {data.map((data: any, index: any) => (
        <>
          <div className="grid text-white mobile:gap-2  m-2 gap-2" style={gridStyle}>
          </div>
        </>
      ))} */}

      {/* <div className="flex justify-center">
        {activeAnotherSeat && (
          <button className="bg-orange-600 border-2 border-white rounded-3xl text-white px-2 py-1">
            Leave Group
          </button>
        )}
      </div> */}
    </div>
  );
};
export default ParticipantExpandedTable;
